import AppContainer from "./js/components/container/AppContainer.jsx";
import React from 'react';
import ReactDOM from 'react-dom';
import '../App.css';

export default function (modules, config, el, message) {    
    const packageInfo = {
        modules: modules,
        config: config,
        message: message,
        el: el
    }
    
    ReactDOM.render(
        <AppContainer packageInfo={packageInfo}/>,
        el
      );
}
// const user = { name: "nishchhal"}
// const wrapper = document.getElementById("create-article-form");
// wrapper ? ReactDOM.render(<GameProvider value={user}><AppContainer /></GameProvider>, wrapper) : false;